import { BehaviorBipFunctionLinkModel, BehaviorFunctionModel } from '../../core/api/models';

export const BIP_FUNCTION_ROLE_PRIMARY = 1;
export const BIP_FUNCTION_ROLE_SECONDARY = 2;

export interface BipFunctionDisplayItem {
  name: string | null | undefined;
  class: string;
  roleLabel?: string | null;
}

export function getBipFunctionCssClass(functionName?: string | null): string {
  switch (functionName) {
    case 'Denied Access / Tangible':
      return 'bg-deniedaccesstangible';
    case 'Escape':
      return 'bg-escape';
    case 'Attention':
      return 'bg-attention';
    case 'Automatic':
      return 'bg-automatic';
    default:
      return 'bg-blue';
  }
}

function functionRoleSortKey(role?: number | null): number {
  if (role === BIP_FUNCTION_ROLE_PRIMARY) return 0;
  if (role === BIP_FUNCTION_ROLE_SECONDARY) return 1;
  return 2;
}

function functionRoleLabel(role?: number | null): string | null {
  if (role === BIP_FUNCTION_ROLE_PRIMARY) return 'Primary';
  if (role === BIP_FUNCTION_ROLE_SECONDARY) return 'Secondary';
  return null;
}

export function getBipFunctionRoleBadge(role?: number | null): string | null {
  if (role === BIP_FUNCTION_ROLE_PRIMARY) return 'P';
  if (role === BIP_FUNCTION_ROLE_SECONDARY) return 'S';
  return null;
}

export function compareBipFunctionRoleOrder(a: { role?: number | null; functionID?: number }, b: { role?: number | null; functionID?: number }): number {
  const roleDiff = functionRoleSortKey(a.role) - functionRoleSortKey(b.role);
  if (roleDiff !== 0) return roleDiff;
  return (a.functionID ?? 0) - (b.functionID ?? 0);
}

export function mapBehaviorBipFunctionsToDisplay(
  lookupFunctions: BehaviorFunctionModel[],
  links?: BehaviorBipFunctionLinkModel[] | null,
  functionIds?: number[] | null
): BipFunctionDisplayItem[] {
  const nameById = new Map<number, string>();
  for (const fn of lookupFunctions ?? []) {
    if (fn.ID != null) {
      nameById.set(fn.ID, fn.FunctionName ?? '');
    }
  }

  let items: { functionID: number; role?: number | null }[] = [];
  if (links?.length) {
    items = links
      .filter(x => (x.FunctionID ?? 0) > 0)
      .map(x => ({ functionID: x.FunctionID!, role: x.Role }));
  } else if (functionIds?.length) {
    items = functionIds.map(id => ({ functionID: id, role: null }));
  }

  items.sort((a, b) => {
    const roleDiff = functionRoleSortKey(a.role) - functionRoleSortKey(b.role);
    if (roleDiff !== 0) return roleDiff;
    return a.functionID - b.functionID;
  });

  return items.map(item => {
    const name = nameById.get(item.functionID);
    return {
      name,
      class: getBipFunctionCssClass(name),
      roleLabel: functionRoleLabel(item.role)
    };
  });
}
